export class Assessment {
    authors: any[] = [];
    claim_holders: any[] = [];
    claims: any[] = [];
    commodities: any[] = [];
    contact_rgp: any[] = [];
    drill_hole_count: 0
    file_id: string;
    file_identifiers: any[] = [];
    file_type: string;
    last_updated_at: string;
    last_updated_detail: string;
    location: any[] = [];
    maps:  any[] = [];
    nts: any[] = [];
    performed_for: any[] = [];
    primary_township: string;
    property_names: []
    resident_geologist_district: string;
    secondary_townships: []
    technical_reports: any[] = [];
    total_value_of_work_approved: number;
    work_types: any[] = [];
    year_from: number;
    year_to: number;
  
    constructor(init?: Partial<Assessment>) {
      Object.assign(this, init);
    }
  }